// extracted by mini-css-extract-plugin
export default {"variation-breadcrumb":"VariationPopup_variation-breadcrumb__x7tcs"};